// extracted by mini-css-extract-plugin
export default {"main":"logodraw_main__vcljx","box":"logodraw_box__mqXvp","name":"logodraw_name__oGeWq"};